import { Controller } from "@hotwired/stimulus";

const crdFieldName = "customer_requested_date";

export default class extends Controller {
  static targets = [
    "soldToSelect",
    "crdBookingPrompt",
    "crdPresetBookingPrompt",
    "crdDateInput",
    "crdBookingWindowSelect",
  ];

  get currentOrderType() {
    return $(this.soldToSelectTarget).data("orderType");
  }

  connect() {
    this.updatePrompt();
    this.updateCrdField();
  }

  orderTypeChange({ currentTarget: { value } }) {
    $(this.soldToSelectTarget).data("orderType", value);
    this.updatePrompt();
    this.updateCrdField();
  }

  updatePrompt() {
    if (this.hasCrdBookingPromptTarget) {
      if (this.currentOrderType == "PRESET_BOOKING") {
        this.crdBookingPromptTarget.style.display = "none";
        this.crdPresetBookingPromptTarget.style.display = "";
      } else {
        this.crdBookingPromptTarget.style.display = "";
        this.crdPresetBookingPromptTarget.style.display = "none";
      }
    }
  }

  updateCrdField() {
    if (this.hasCrdDateInputTarget) {
      if (this.currentOrderType == "PRESET_BOOKING") {
        this.crdDateInputTarget.style.display = "none";
        this.crdDateInputTarget.name = null;
        this.crdBookingWindowSelectTarget.style.display = "";
        this.crdBookingWindowSelectTarget.name = crdFieldName;
      } else {
        this.crdDateInputTarget.style.display = "";
        this.crdDateInputTarget.name = crdFieldName;
        this.crdBookingWindowSelectTarget.style.display = "none";
        this.crdBookingWindowSelectTarget.name = null;
      }
    }
  }
}
